import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  Commission: [],
  Detail: [],

};
//internally using immer lib (can create mutable state)
export const commissionSlice = createSlice({
  name: "commissionData",
  initialState,
  reducers: {
    updateAllCommission: (state, action) => {
      state.Commission = action.payload;
    },
    commissionDetail: (state, action) => {
      state.Detail = action.payload;
    },
  },
});
// this is for dispatch
export const { updateAllCommission,commissionDetail } = commissionSlice.actions;
// this is for configureStore
export default commissionSlice.reducer;
